// True when the app is being served from a developer's machine. Used to gate development-only
// affordances that must never appear in a deployed build.
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]', '::1'];

export const isLocalhost = () => {
  try {
    return LOCAL_HOSTNAMES.includes(window.location.hostname);
  } catch (e) {
    return false;
  }
};
